import '.aj{flex-shrink:0;}.ssr-plugin'
import '.aa{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.au{height:100%;}.ssr-plugin'
import '.aw{border:none;}.ssr-plugin'
import '.co{background-color:transparent;}.ssr-plugin'
import '.cp{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.b0{position:sticky;}.ssr-plugin'
import '.cq{top:4rem;}.ssr-plugin'
import '.cr{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.cs{padding-bottom:1rem;}.ssr-plugin'
import '.ct{margin-bottom:1rem;}.ssr-plugin'
import '.cu{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.b1{top:0px;}.ssr-plugin'
import '.b8{left:0px;}.ssr-plugin'
import '.b9{right:0px;}.ssr-plugin'
import '.ba{bottom:0px;}.ssr-plugin'
import '.cv{z-index:9999;}.ssr-plugin'
import '.cw{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.az{justify-content:flex-end;}.ssr-plugin'
import '.av{flex:1;}.ssr-plugin'
import '.bk{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="aj aa n au aw co cp"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a8"
    >
      <div className="b0 cq cr t cs ct cu d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i b1 b8 b9 ba cv t cw d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aa d az cu"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="av bk">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
